import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }

import { withDefaults, computed } from 'vue';
import {
  BaseButton,
  BaseDescriptions,
  BaseDescriptionsItem,
  BaseToolTip
} from 'xrk-components';
import { FILE_VIEW_URL } from '@/config';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'question-detail-19',
  props: {
    questionInfo: { default: () => ({}) }
  },
  emits: ['changeImgUrl'],
  setup(__props: any, { emit: __emit }) {

const store = useProjectDetailStore();


const emits = __emit;

//协定服务上传来源1ASP上传2C端上传3双方共同上传
const agreementServiceUploadType = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadType;
});

//协定服务上传方式1以活动方式上传2以人为维度上传
const agreementServiceUploadMode = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadMode;
});
const isEntry = [
  +agreementServiceUploadMode.value,
  +agreementServiceUploadType.value
].join(',');
// '1,3': '活动形式-双方共同上传',
// '1,1': '活动形式-服务商上传',
// '2,2': '人为维度-终端上传',
// '2,1': '人为维度-服务商上传',

const uploadSource = computed(() => {
  switch (isEntry) {
    case '1,3':
      return '终端上传';
    case '1,1':
      return '终端上传';
    case '2,2':
      return '终端上传';
    case '2,1':
      return '服务商上传';
    default:
      return '';
  }
});

const getTitle = topic => {
  return topic.label;
};

//文件预览
const onViewer = url => {
  const imageTypeReg = new RegExp(/\.bmp|\.jpg|\.png|\.gif|\.jpeg/, 'i');
  if (imageTypeReg.test(url)) {
    emits('changeImgUrl', url);
    return;
  }
  window.open(`${FILE_VIEW_URL}?t=${Date.now()}&url=${url}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionInfo, (topic, index) => {
      return (_openBlock(), _createBlock(_unref(BaseDescriptions), {
        key: index,
        title: getTitle(topic),
        column: 1,
        size: "large",
        direction: "vertical"
      }, {
        default: _withCtx(() => [
          (topic.remark)
            ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), {
                key: 0,
                label: `备注：${topic.remark}`
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          _createElementVNode("template", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topic.values, (value, index) => {
              return (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), {
                key: value + index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(BaseToolTip), {
                      placement: "top",
                      effect: "dark",
                      content: value.name,
                      disabled: value.name < 22
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BaseButton), {
                          disabled: !value.url,
                          onClick: ($event: any) => (onViewer(value.url)),
                          type: "text"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(value.name.length > 22
                    ? value.name.slice(0, 22) + '...'
                    : value.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["content", "disabled"]),
                    _createElementVNode("span", null, "【" + _toDisplayString(value.uploadSource || uploadSource.value) + "】", 1)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]),
        _: 2
      }, 1032, ["title"]))
    }), 128))
  ]))
}
}

})